import styled from 'styled-components'

export const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  div {
    width: 32px;
    height: 32px;
  }
`
